import { LogoutOutlined, SettingOutlined } from "@ant-design/icons";
import { Avatar, Button, Dropdown, Space, Typography } from "antd";
import ElegirFilialUsuario from "components/ElegirFilialUsuario";
import useLogout from "hooks/useLogout";
import { useState } from "react";
import { Link } from "react-router-dom";
import { lowerAndCapitalizeFirstLetter } from "utils";

const UserMenu = ({ usuario, buttonStyles }) => {
  const { logout } = useLogout();
  const [openFiliales, setOpenFiliales] = useState(false);

  const nombre = usuario?.personal?.nombre;

  const items = [
    {
      icon: <SettingOutlined />,
      label: (
        <Link to="/configuracion">
          Configuración
        </Link>
      ),
      key: '/configuracion',
    }, {
      icon: <LogoutOutlined />,
      label: "Salir",
      key: 'salir',
      onClick: () => {
        if (usuario?.filiales?.length > 1) {
          setOpenFiliales(true);
        } else {
          logout();
        }
      }
    },
  ];

  return (
    <>
      <Dropdown
        menu={{ items }}
        trigger={['click']}
      >
        <Button
          type="text"
          style={{
            fontSize: buttonStyles?.fontSize,
            height: buttonStyles?.height,
          }}
        >
          <Space direction="horizontal" size="small" align="center">
            <Avatar size="default">
              {nombre[0]}
            </Avatar>
            <Typography.Text style={{ color: buttonStyles?.color }}>
              {lowerAndCapitalizeFirstLetter(nombre)}
            </Typography.Text>
          </Space>
        </Button>
      </Dropdown>
      {openFiliales &&
        <ElegirFilialUsuario
          filiales={usuario?.filiales}
          usuarioId={usuario?.id}
          onClose={() => setOpenFiliales(false)}
        />
      }
    </>
  );
};

export default UserMenu;